import React from 'react';
import { domainSpellingCheck } from '../../../utils/passwordValidations';
import { getTexts } from '../../../lib/contentful/defaultTexts';
import { flipView, setEmail } from '../../../store/reducer';
import { interactionsRioEvent } from '../../../lib/rio/rioEvents';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { PxCaptchaTypes, View } from '../../../store/types';
import { setGenericError, setLoading } from '../../../store/sharedActions';
import { InputErrorButton } from '../../shared.styles';
var EmailInputErrorButton = function EmailInputErrorButton(_ref) {
  var value = _ref.value,
    error = _ref.error;
  var dispatch = useAppDispatch();
  var pxCaptchaType = useAppSelector(function (state) {
    return state.pxCaptchaType;
  });
  var correctedEmailObj = domainSpellingCheck(value);
  switch (error) {
    case "".concat(getTexts().signup.emailMisspellError, " ").concat(correctedEmailObj === null || correctedEmailObj === void 0 ? void 0 : correctedEmailObj.domain, "?"):
      {
        return /*#__PURE__*/React.createElement(InputErrorButton, {
          "data-test": "replace_button",
          onClick: function onClick() {
            dispatch(setEmail({
              email: "".concat(correctedEmailObj === null || correctedEmailObj === void 0 ? void 0 : correctedEmailObj.email)
            }));
            interactionsRioEvent({
              interaction: {
                type: 'click',
                element: {
                  type: 'button',
                  name: 'replace misspelled email domain',
                  region_name: 'below email input'
                }
              }
            });
          }
        }, getTexts().signup.replaceEmailText);
      }
    case getTexts().signup.emailRegisteredError:
      {
        return /*#__PURE__*/React.createElement(InputErrorButton, {
          "data-test": "existing_email_flip_button",
          onClick: function onClick() {
            interactionsRioEvent({
              interaction: {
                type: 'click',
                element: {
                  type: 'link',
                  name: 'flip to sign in page',
                  region_name: 'below email input'
                }
              }
            });
            dispatch(flipView({
              view: View.SIGNIN
            }));
            if (pxCaptchaType === PxCaptchaTypes.SIGNUP) {
              dispatch(setGenericError({
                error: '',
                onView: View.SIGNIN
              }));
              dispatch(setLoading({
                loading: false,
                onView: View.SIGNIN
              }));
            }
            dispatch(setEmail({
              email: value
            }));
          }
        }, getTexts().signup.signInText);
      }
    case getTexts().signup.userExistsInMigrationClientError:
      {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputErrorButton, {
          className: "mergedError",
          "data-test": "existing_email_flip_button",
          onClick: function onClick() {
            interactionsRioEvent({
              interaction: {
                type: 'click',
                element: {
                  type: 'link',
                  name: 'flip to sign in page',
                  region_name: 'below email input'
                }
              }
            });
            dispatch(flipView({
              view: View.SIGNIN
            }));
            if (pxCaptchaType === PxCaptchaTypes.SIGNUP) {
              dispatch(setGenericError({
                error: '',
                onView: View.SIGNIN
              }));
              dispatch(setLoading({
                loading: false,
                onView: View.SIGNIN
              }));
            }
            dispatch(setEmail({
              email: value
            }));
          }
        }, getTexts().signup.signInText), getTexts().signup.mathwayCredentialsErrorText, /*#__PURE__*/React.createElement(InputErrorButton, {
          className: "mergedError",
          "data-test": "existing_email_flip_reset_password_button",
          onClick: function onClick() {
            interactionsRioEvent({
              interaction: {
                type: 'click',
                element: {
                  type: 'link',
                  name: 'flip to reset password page',
                  region_name: 'below email input'
                }
              }
            });
            dispatch(flipView({
              view: View.RESET_PASSWORD
            }));
            if (pxCaptchaType === PxCaptchaTypes.SIGNUP) {
              dispatch(setGenericError({
                error: '',
                onView: View.RESET_PASSWORD
              }));
              dispatch(setLoading({
                loading: false,
                onView: View.RESET_PASSWORD
              }));
            }
            dispatch(setEmail({
              email: value
            }));
          }
        }, getTexts().signup.resetPasswordText));
      }
    default:
      {
        return null;
      }
  }
};
export default EmailInputErrorButton;